<template>
  <div class="w-11/12 mx-auto flex-row flex-wrap justify-between font-costea pb-12">
    <div class="flex flex-row justify-between pt-3 pb-2 mb-6 mt-2 border-b-2 flex-wrap">
      <h1 class="font-costea text-h24 font-medium text-costeaBlack mb-4 md:mb-0">
        Dashboard
      </h1>
      <div class="flex flex-row items-center">
          <form action="#">
              <select v-model="catSelectedHome" name="" id="" class="flex bg-white justify-center items-center py-2 px-2 text-t14 text-costeaDarkGray">
                <option value="" disabled>Seleccione una cat</option>
                <option 
                    v-for="cat in categories" 
                    :key="cat.id" 
                    :value="parseInt(cat.id)">
                        Categoría: {{cat.name}}
                </option>
              </select>
          </form>
      </div>
    </div>

    <div>
        <RankingHome :catSelected="parseInt(catSelectedHome)"/>
    </div>


    <div class="bg-white w-full mt-10">
        <ChartHome :catSelected="parseInt(catSelectedHome)"/>
    </div>

  </div>
</template>

<script>
import ChartHome from '@/components/home/ChartHome.vue'
import RankingHome from '@/components/home/RankingHome.vue'
import {mapState} from 'vuex'
import axios from 'axios'
export default {

    name:'home',
    components:{
        ChartHome,
        RankingHome
    },
    data(){
        return{
            catSelectedHome:'1',
            categories:[]
        }
    },
    created(){
      this.getCategories()
    },
    computed:{
        ...mapState(['costea'])
    },
    methods:{
      getCategories(){
          axios
          .get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}categories`)
            .then( respuesta => {
                this.categories = respuesta.data;
                console.log(respuesta.data)
            }).catch (
                (error) => {
                    console.log(error.err_.message)
                    this.$router.push('/login')
                }
            );
      }
    }
}
</script>

<style>

</style>